module.exports = {"500116001":"几江街道","500116002":"德感街道","500116004":"双福街道","500116005":"鼎山街道","500116101":"油溪镇","500116102":"吴滩镇","500116103":"石门镇","500116104":"朱杨镇","500116105":"石蟆镇","500116106":"永兴镇","500116107":"塘河镇","500116108":"白沙镇","500116109":"龙华镇","500116110":"李市镇","500116111":"慈云镇","500116112":"蔡家镇","500116113":"中山镇","500116114":"嘉平镇","500116115":"柏林镇","500116116":"先锋镇","500116117":"珞璜镇","500116118":"贾嗣镇","500116119":"夏坝镇","500116120":"西湖镇","500116121":"杜市镇","500116122":"广兴镇","500116123":"四面山镇","500116124":"支坪镇","500116125":"四屏镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/500116.json
// module id = 2050
// module chunks = 0